// /**
//  * Mapping frontend ↔ API Spring Boot (source of truth: Enums.java)
//  *
//  * TypeContenu   { ARTICLE, ALERTE, VERIFICATION, EXPLICATIF, VIDEO, AUDIO, DIRECT, EDITORIAL, CORRECTION, SYNDIQUE }
//  * Signature     { REDACTION, REDACTION_VERIFIEE }
//  * StatutContenu { BROUILLON, RELECTURE, JURIDIQUE, PUBLIE, ARCHIVE }
//  * CodeLangue    { FR, EN, BM, HA, MOS }
//  * FormatVerif   { TEXTE, IMAGE, AUDIO, VIDEO, CAPTURE }
//  * Verdict       { FAUX, TROMPEUR, NON_PROUVE, VRAI, CONTEXTE }
//  */

// // ─── TypeContenu ──────────────────────────────────────────────────────────────
// export const TYPE_CONTENU_TO_API: Record<string, string> = {
//   article:    "ARTICLE",
//   alert:      "ALERTE",
//   factcheck:  "VERIFICATION",
//   explainer:  "EXPLICATIF",
//   video:      "VIDEO",
//   audio:      "AUDIO",
//   live:       "DIRECT",
//   editorial:  "EDITORIAL",
//   correction: "CORRECTION",
//   syndicated: "SYNDIQUE",
// };

// export const TYPE_CONTENU_FROM_API: Record<string, string> = {
//   ARTICLE:      "article",
//   ALERTE:       "alert",
//   VERIFICATION: "factcheck",
//   EXPLICATIF:   "explainer",
//   VIDEO:        "video",
//   AUDIO:        "audio",
//   DIRECT:       "live",
//   EDITORIAL:    "editorial",
//   CORRECTION:   "correction",
//   SYNDIQUE:     "syndicated",
// };

// export const TYPE_CONTENU_OPTIONS: { value: string; label: string }[] = [
//   { value: "article",    label: "Article" },
//   { value: "alert",      label: "Alerte" },
//   { value: "factcheck",  label: "Fact-check / Vérification" },
//   { value: "explainer",  label: "Explicatif / Décryptage" },
//   { value: "video",      label: "Vidéo" },
//   { value: "audio",      label: "Audio" },
//   { value: "live",       label: "Direct" },
//   { value: "editorial",  label: "Éditorial" },
//   { value: "correction", label: "Correction" },
//   { value: "syndicated", label: "Syndiqué" },
// ];

// // ─── Signature ────────────────────────────────────────────────────────────────
// export const SIGNATURE_OPTIONS: { value: string; label: string }[] = [
//   { value: "REDACTION",          label: "Rédaction RAMBA NEWS" },
//   { value: "REDACTION_VERIFIEE", label: "Rédaction vérifiée" },
// ];

// export const SIGNATURE_LABEL: Record<string, string> = {
//   REDACTION:          "Rédaction RAMBA NEWS",
//   REDACTION_VERIFIEE: "Rédaction vérifiée",
// };

// // ─── StatutContenu (corrigé : RELECTURE et JURIDIQUE, pas EN_COURS) ───────────
// export const STATUT_MAP: Record<string, string> = {
//   BROUILLON:  "Brouillon",
//   RELECTURE:  "En relecture",
//   JURIDIQUE:  "Validation juridique",
//   PUBLIE:     "Publié",
//   ARCHIVE:    "Archivé",
// };

// export const STATUTS_FILTRES = [
//   { value: "",           label: "Tous" },
//   { value: "BROUILLON",  label: "Brouillon" },
//   { value: "RELECTURE",  label: "En relecture" },
//   { value: "JURIDIQUE",  label: "Validation juridique" },
//   { value: "PUBLIE",     label: "Publié" },
//   { value: "ARCHIVE",    label: "Archivé" },
// ];

// // ─── CodeLangue (API attend FR, EN, BM, HA, MOS en majuscules) ───────────────
// export const LANGUES_CONFIG = [
//   { code: "fr", apiCode: "FR", label: "Français",  flag: "🇫🇷" },
//   { code: "en", apiCode: "EN", label: "English",   flag: "🇬🇧" },
//   { code: "bm", apiCode: "BM", label: "Bambara",   flag: "🌍" },
//   { code: "ha", apiCode: "HA", label: "Haoussa",   flag: "🌍" },
//   { code: "mos",apiCode: "MOS",label: "Mooré",     flag: "🌍" },
// ];

// /** Convertit un code langue frontend ("fr") → API ("FR") */
// export const langToApi = (code: string) => code.toUpperCase();
// /** Convertit un code langue API ("FR") → frontend ("fr") */
// export const langFromApi = (code: string) => code.toLowerCase();

// // ─── FormatVerification (corrigé : TEXTE, IMAGE, AUDIO, VIDEO, CAPTURE) ──────
// export const FORMAT_VERIFICATION_OPTIONS: { value: string; label: string }[] = [
//   { value: "TEXTE",   label: "Texte / Article" },
//   { value: "IMAGE",   label: "Image" },
//   { value: "AUDIO",   label: "Audio" },
//   { value: "VIDEO",   label: "Vidéo" },
//   { value: "CAPTURE", label: "Capture d'écran" },
// ];

// // ─── Verdict (corrigé : NON_PROUVE et non NON_VERIFIE) ───────────────────────
// export const VERDICT_OPTIONS = [
//   { value: "FAUX",       label: "Faux",        color: "bg-red-100 text-red-700 border-red-200" },
//   { value: "TROMPEUR",   label: "Trompeur",    color: "bg-orange-100 text-orange-700 border-orange-200" },
//   { value: "NON_PROUVE", label: "Non prouvé",  color: "bg-yellow-100 text-yellow-700 border-yellow-200" },
//   { value: "VRAI",       label: "Vrai",        color: "bg-green-100 text-green-700 border-green-200" },
//   { value: "CONTEXTE",   label: "Contexte",    color: "bg-blue-100 text-blue-700 border-blue-200" },
// ];

// // ─── Générateur de slug ───────────────────────────────────────────────────────
// export function generateSlug(titre: string): string {
//   return titre
//     .toLowerCase()
//     .normalize("NFD")
//     .replace(/[\u0300-\u036f]/g, "")  // retire les accents
//     .replace(/[^a-z0-9\s-]/g, "")
//     .trim()
//     .replace(/\s+/g, "-")
//     .replace(/-+/g, "-")
//     .slice(0, 80)
//     + "-" + Date.now().toString(36);   // suffixe unique
// }
/**
 * Mapping frontend ↔ API Spring Boot (source of truth: Enums.java)
 *
 * TypeContenu   { ARTICLE, ALERTE, VERIFICATION, EXPLICATIF, VIDEO, AUDIO, DIRECT, EDITORIAL, CORRECTION, SYNDIQUE }
 * Signature     { REDACTION, REDACTION_VERIFIEE }
 * StatutContenu { BROUILLON, RELECTURE, JURIDIQUE, PUBLIE, ARCHIVE }
 * CodeLangue    { FR, EN, BM, HA, MOS }
 * FormatVerif   { TEXTE, IMAGE, AUDIO, VIDEO, CAPTURE }
 * Verdict       { FAUX, TROMPEUR, NON_PROUVE, VRAI, CONTEXTE }
 */

// ─── TypeContenu ──────────────────────────────────────────────────────────────
export const TYPE_CONTENU_TO_API: Record<string, string> = {
  article:    "ARTICLE",
  alert:      "ALERTE",
  factcheck:  "VERIFICATION",
  explainer:  "EXPLICATIF",
  video:      "VIDEO",
  audio:      "AUDIO",
  live:       "DIRECT",
  editorial:  "EDITORIAL",
  correction: "CORRECTION",
  syndicated: "SYNDIQUE",
};

export const TYPE_CONTENU_FROM_API: Record<string, string> = {
  ARTICLE:      "article",
  ALERTE:       "alert",
  VERIFICATION: "factcheck",
  EXPLICATIF:   "explainer",
  VIDEO:        "video",
  AUDIO:        "audio",
  DIRECT:       "live",
  EDITORIAL:    "editorial",
  CORRECTION:   "correction",
  SYNDIQUE:     "syndicated",
};

export const TYPE_CONTENU_OPTIONS: { value: string; label: string }[] = [
  { value: "article",    label: "Article" },
  { value: "alert",      label: "Alerte" },
  { value: "factcheck",  label: "Fact-check / Vérification" },
  { value: "explainer",  label: "Explicatif / Décryptage" },
  { value: "video",      label: "Vidéo" },
  { value: "audio",      label: "Audio" },
  { value: "live",       label: "Direct" },
  { value: "editorial",  label: "Éditorial" },
  { value: "correction", label: "Correction" },
  { value: "syndicated", label: "Syndiqué" },
];

// ─── Signature ────────────────────────────────────────────────────────────────
export const SIGNATURE_OPTIONS: { value: string; label: string }[] = [
  { value: "REDACTION",            label: "Rédaction RAMBA NEWS" },
  { value: "REDACTION_PARTENAIRE", label: "Rédaction Partenaire" },
];

export const SIGNATURE_LABEL: Record<string, string> = {
  REDACTION:            "Rédaction RAMBA NEWS",
  REDACTION_PARTENAIRE: "Rédaction Partenaire",
};

// ─── StatutContenu (corrigé : RELECTURE et JURIDIQUE, pas EN_COURS) ───────────
export const STATUT_MAP: Record<string, string> = {
  BROUILLON:  "Brouillon",
  RELECTURE:  "En relecture",
  JURIDIQUE:  "Validation juridique",
  PROGRAMME:  "Programmé",
  PUBLIE:     "Publié",
  ARCHIVE:    "Archivé",
  REFUSE:     "Refusé",
};

export const STATUTS_FILTRES = [
  { value: "",           label: "Tous" },
  { value: "BROUILLON",  label: "Brouillon" },
  { value: "RELECTURE",  label: "En relecture" },
  // { value: "JURIDIQUE",  label: "Validation juridique" },
  { value: "PROGRAMME",  label: "Programmé" },
  { value: "PUBLIE",     label: "Publié" },
  // { value: "ARCHIVE",    label: "Archivé" },
  { value: "REFUSE",     label: "Refusé" },
];

// ─── CodeLangue (API attend FR, EN, BM, HA, MOS en majuscules) ───────────────
export const LANGUES_CONFIG = [
  { code: "fr", apiCode: "FR", label: "Français",  flag: "🇫🇷" },
  { code: "en", apiCode: "EN", label: "English",   flag: "🇬🇧" },
  // { code: "bm", apiCode: "BM", label: "Bambara",   flag: "🌍" },
  // { code: "ha", apiCode: "HA", label: "Haoussa",   flag: "🌍" },
  // { code: "mos",apiCode: "MOS",label: "Mooré",     flag: "🌍" },
];

/** Convertit un code langue frontend ("fr") → API ("FR") */
export const langToApi = (code: string) => code.toUpperCase();
/** Convertit un code langue API ("FR") → frontend ("fr") */
export const langFromApi = (code: string) => code.toLowerCase();

// ─── FormatVerification (corrigé : TEXTE, IMAGE, AUDIO, VIDEO, CAPTURE) ──────
export const FORMAT_VERIFICATION_OPTIONS: { value: string; label: string }[] = [
  { value: "TEXTE",   label: "Texte / Article" },
  { value: "IMAGE",   label: "Image" },
  { value: "AUDIO",   label: "Audio" },
  { value: "VIDEO",   label: "Vidéo" },
  { value: "CAPTURE", label: "Capture d'écran" },
];

// ─── Verdict (corrigé : NON_PROUVE et non NON_VERIFIE) ───────────────────────
export const VERDICT_OPTIONS = [
  { value: "FAUX",       label: "Faux",        color: "bg-red-100 text-red-700 border-red-200" },
  { value: "TROMPEUR",   label: "Trompeur",    color: "bg-orange-100 text-orange-700 border-orange-200" },
  { value: "NON_PROUVE", label: "Non prouvé",  color: "bg-yellow-100 text-yellow-700 border-yellow-200" },
  { value: "VRAI",       label: "Vrai",        color: "bg-green-100 text-green-700 border-green-200" },
  { value: "CONTEXTE",   label: "Contexte",    color: "bg-blue-100 text-blue-700 border-blue-200" },
];

// ─── Générateur de slug ───────────────────────────────────────────────────────
export function generateSlug(titre: string, categorieSlug?: string): string {
  const normalize = (s: string) =>
    s.toLowerCase()
     .normalize("NFD")
     .replace(/[\u0300-\u036f]/g, "")
     .replace(/[^a-z0-9\s-]/g, "")
     .trim()
     .replace(/\s+/g, "-")
     .replace(/-+/g, "-");

  const titreSlug = normalize(titre).slice(0, 60);
  const suffix = Date.now().toString(36);
  const prefix = categorieSlug ? normalize(categorieSlug) + "-" : "";
  return `${prefix}${titreSlug}-${suffix}`;
}